import React, { useState, useCallback } from 'react';
import Response from 'screens/company-user/job/job-v1/responses/response';

import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job, JobMatchStageEnum } from '@libs/graphql-types';

import ArrowMatchesTabs from './arrow-matches-tabs';
import { useJobMatchesByStage, useJobMatchTabs } from './hooks';
import NewActionsBlock from './new-actions-block';
import { ConfirmStageChangeModal } from './new-actions-block/ConfirmStageChangeModal';
import { ProposeCandidate } from './propose-candidate';

const useStyles = makeStyles((theme: any) => ({
  root: {
    // No background or padding
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
  responseContainer: {
    marginBottom: theme.spacing(4),
  },
}));

interface AtsProps {
  jobData: Job;
}

export const Ats: React.FC<AtsProps> = ({ jobData }) => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState<JobMatchStageEnum>(
    JobMatchStageEnum.InstantMatch,
  );

  const matchesByStage = useJobMatchesByStage(jobData);
  const matchTabs = useJobMatchTabs(matchesByStage);
  const currentMatches = matchesByStage[currentTab] || [];

  const handleTabChange = useCallback((tabId: JobMatchStageEnum) => {
    setCurrentTab(tabId);
  }, []);

  const refreshCandidates = () => {
    // Mock refresh function - in a real app, this would refresh the candidates list
    console.log('Refreshing candidates');
  };

  return (
    <Box className={classes.root}>
      <Box mb={6}>
        <ProposeCandidate job={jobData} />
      </Box>

      <Box mb={4}>
        <ArrowMatchesTabs
          tabs={matchTabs}
          currentActive={currentTab}
          onChange={handleTabChange}
        />
      </Box>

      {/* Candidate Cards using the Response component */}
      {(currentMatches || [])
        .filter((jobMatch): jobMatch is NonNullable<typeof jobMatch> =>
          Boolean(jobMatch),
        )
        .map((jobMatch) => (
          <Box key={jobMatch.id} className={classes.responseContainer}>
            <Response
              jobMatch={jobMatch as any}
              isSaved={false}
              job={jobData as any}
              refresh={refreshCandidates}
              CustomActionsBlock={(props) => (
                <NewActionsBlock {...(props as any)} />
              )}
            />
          </Box>
        ))}
      <ConfirmStageChangeModal />
    </Box>
  );
};
